export default __webpack_public_path__ + "static/media/searpent_logo_black_long.2f540262.png";